import * as logger from 'logger';
import * as nmvsApi from 'api/nmvs-api';
import { addAlert } from 'services/alert-service';
import { addOrUpdateCompletedItem, updateItemToError } from 'services/item-service';
import { convertMsToSeconds, getElapsedMsSinceRequestStarted } from 'helpers/date-helper';
import { getNmvsWarning } from './data-sync-error-helpers';
import { NmvsActionType } from 'types/nmvs-action-type';
import { NmvsResponse } from 'types/api/nmvs-response';
import { OperationItem } from 'types/operation-item';
// import { SinglePackResponse } from 'types/api/single-pack-response';
import { VerifyBrandResponse } from 'types/api/verifybrand-response';

export async function performApiCall(key: string, item: OperationItem): Promise<NmvsResponse<VerifyBrandResponse>> {
  try {
      let response: NmvsResponse<VerifyBrandResponse>;
      switch (item.operation) {
        case NmvsActionType.Verify:
          response = await nmvsApi.getCodeStatus(item);
          break;
        case NmvsActionType.Dispense:
          response = await nmvsApi.dispense(item);
          break;
          // case NmvsActionType.Sample:
          //   response = await nmvsApi.sample(item);
          //   break;
          // case NmvsActionType.UndoDispense:
          //   response = await nmvsApi.undoDispense(item);
          //   break;
          // case NmvsActionType.UndoSample:
          //   response = await nmvsApi.undoSample(item);
          //   break;
        case NmvsActionType.Destroy:
          response = await nmvsApi.destroy(item);
          break;
      default:
        throw new Error('dataSyncApiHelper.performApiCall OperationItem.operation not set');
    }

      return response;
  }
  catch (error) {
    // if api call fails, need to move item to error
    logger.error(error, 'service-worker.performApiCall');
    await updateItemToError(key, item);
    throw error;
  }
}

export async function handleNmvsResponse(
  // tslint:disable-next-line: no-any
  clientTransactionId: string, item: OperationItem, response: any) {
  item.totalResponseTime = convertMsToSeconds(getElapsedMsSinceRequestStarted(item, new Date()));
  if (true) {
  // if (response.result.Status !== null) {
    item.epc.status = response.Status.Name;
    item.epc.primaryPropName = response.PrimaryProperty.Name;
    item.epc.primaryPropValue = response.PrimaryProperty.Value;
    if ('Properties' in response) {
      item.epc.properties = {};
      for (var property of Object.keys(response.Properties)) {
        item.epc.properties[property] = response.Properties[property];
      }
    }
    item.epc.serialNumber = item.epc.rawCode;

    item.hasAlert = response.hasAlert;
    item.hasError = response.hasError;

    if (false) {
      item.hasAlert = true;
      const warning = await getNmvsWarning();
      await addAlert(clientTransactionId, item, '', warning, response.result.Status);
    }
    await addOrUpdateCompletedItem(clientTransactionId, item);
  }
}



// WEBPACK FOOTER //
// ./src/service-worker/helpers/data-sync-api-helpers.ts